import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StockItem, StockItemService } from './../../acumatica/EntityServices/StockItem.service';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'item-thumbnail',
  templateUrl: './item-thumbnail.component.html',
  styleUrls: ['./item-thumbnail.component.css']
})
export class ItemThumbnailComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    private stockItems: StockItemService,
  ) { }

  innerWidth: number = 0;
  ngOnInit() {
    this.innerWidth = window.innerWidth;
  }

  private _item: StockItem | null | undefined;
  // @Input() item?: StockItem | null | undefined;
  get item() { return this._item; }
  @Input() set item(value) {
    // memo items, fetch the primary item
    if (value && value.ItemClassID == '50') {
      this.stockItems.get(value.InventoryID.substring(1), { loader: null }).subscribe(item => {
        this._item = item;
      }, err => this._item = value);
    }
    else this._item = value;
  }

  @Input() size: number = 30;
  get pxSize(): string { return this.size.toString() + 'px'; } // pixel size of image
  get phSize(): string { return (this.size - 2).toString() + 'px'; } // placeholder size
  @Input() placeholder = true;
  @Output() click = new EventEmitter<MouseEvent>();

  dialogRef!: MatDialogRef<ElementRef>;
  onClick(dialogViewerRef: TemplateRef<ElementRef>, event: MouseEvent) {
    this.click.emit(event);
    if (event.defaultPrevented) return;
    event.stopPropagation();

    if (this.item) this.dialogRef = this.dialog.open(dialogViewerRef, {
      width: '100vw',
      maxWidth: '100vw',
      panelClass: 'item-image-dialog',
      disableClose: false
    });
  }
}
